import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const Banner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const r = await axios.get(`${API}/banner`);
        if (r.data.active && r.data.text) setBanner(r.data);
      } catch (e) {}
    };
    fetchBanner();
  }, []);

  if (!banner || dismissed) return null;

  const content = (
    <span className="inline-flex items-center gap-3 text-sm font-bold tracking-wide">
      <span className="animate-pulse text-lg">&#9733;</span>
      <span>{banner.text}</span>
      <span className="animate-pulse text-lg">&#9733;</span>
    </span>
  );

  return (
    <div
      className="w-full relative overflow-hidden"
      style={{ backgroundColor: banner.bg_color, color: banner.text_color }}
      dir="rtl"
      data-testid="site-banner"
    >
      {/* Shimmer overlay */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 opacity-10" style={{
          background: `linear-gradient(90deg, transparent 0%, ${banner.text_color} 50%, transparent 100%)`,
          animation: 'shimmer 3s ease-in-out infinite',
          transform: 'translateX(-100%)',
        }} />
      </div>

      {/* Scrolling marquee for mobile, centered for desktop */}
      <div className="py-2.5 px-8 text-center relative z-10">
        {banner.link ? (
          <a href={banner.link} className="hover:underline" style={{ color: banner.text_color }}>
            {content}
          </a>
        ) : (
          content
        )}
      </div>

      <button
        onClick={() => setDismissed(true)}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-20 p-1 rounded-full opacity-50 hover:opacity-100 transition-opacity"
        style={{ backgroundColor: `${banner.text_color}20` }}
        data-testid="banner-dismiss"
      >
        <X className="w-3.5 h-3.5" style={{ color: banner.text_color }} />
      </button>

      <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
};

export default Banner;
